// extracted by mini-css-extract-plugin
module.exports = {"appdefsManage":"manage__appdefsManage__+1xPT","pageTop":"manage__pageTop__AdImj","manageHeldLicenses":"manage__manageHeldLicenses__altZl"};